module.exports = __webpack_public_path__ + "img/yujingbtns.a0c16ecf.png";